import { assign } from 'lodash';
import { mutations as baseMutations, MUTATION_TYPES as BASE_MUTATION_TYPES } from '../base-collection/mutations';
import { STATE_KEYS } from './state';

const MUTATION_TYPES = assign({}, BASE_MUTATION_TYPES, {
  SET_FIRST_TIME_USER: 'setFirstTime',
  SET_STARTED_VIDEO_URL: 'setStartedVideo',
  SET_ONBOARDING_ITEMS: 'setOnboardingItems',
  SET_FEATURE_FLAGS: 'setFeatureFlags',
});

const mutations = assign({}, baseMutations, {
  [MUTATION_TYPES.SET_FIRST_TIME_USER](state, flag) {
    state[STATE_KEYS.IS_FIRST_TIME_USER] = flag;
  },
  [MUTATION_TYPES.SET_STARTED_VIDEO_URL](state, url) {
    state[STATE_KEYS.STARTED_VIDEO_URL] = url;
  },
  [MUTATION_TYPES.SET_ONBOARDING_ITEMS](state, items) {
    state[STATE_KEYS.ONBOARDING_ITEMS] = [...items];
  },
  [MUTATION_TYPES.SET_FEATURE_FLAGS](state, items) {
    state[STATE_KEYS.FEATURE_FLAGS] = items || {};
  },
});

export {
  mutations,
  MUTATION_TYPES,
};
